/**
 * 서류 등록 v1 목록 (/m/docs/v1) — 화면은 $j.F.Docs.v1.Index 가 그린다. 서버 값은 #page-data
 * ($j.Pages.Mobile.DocsV1 / body data-page-name="DocsV1")
 */
export default class DocsV1 {
    initialize() {
        $j.Ui.Div.open({
            id: 'docs-v1-host',
            target: '$j.F.Docs.v1.Index',
            data: JSON.parse(document.getElementById('page-data')?.textContent || '{}'),
        });
    }
}
